import { render, staticRenderFns } from "./uploadImgCornerImg.vue?vue&type=template&id=646e61c0&scoped=true"
import script from "./uploadImgCornerImg.vue?vue&type=script&lang=js"
export * from "./uploadImgCornerImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImgCornerImg.vue?vue&type=style&index=0&id=646e61c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e61c0",
  null
  
)

export default component.exports